<template>
  <footer
    class="footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="/sophrologie/">La sophrologie</a>
          </li>
          <li>
            <a href="/pratique-eft/">EFT</a>
          </li>
          <li>
            <a href="/services/">Séances</a>
          </li>
          <li>
            <a href="/profil/">Mon profil</a>
          </li>
          <li>
            <a href="https://sophrologues.nosavis.com">NosAvis.com</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
